// Source of truth for both the role-editor tri-state and sidebar/route gating.
// Read tier = view-only keys (.read/.view/.aging); write tier = mutating keys.
// Menus listed here are gated; menus absent from the catalog are always visible
// (dashboard, ledger, reports, consol — no permission key exists for them).
export const MENU_CATALOG = [
    // NOTE on key uniqueness: each permission key appears in EXACTLY ONE menu's
    // read/write sets, EXCEPT 'user.manage' (intentionally shared by settings/users
    // + settings/audit — both admin screens). The 'coa' view menu (ผังบัญชี) and
    // 'ledger'/'reports'/'consol'/'dashboard' are deliberately ABSENT (view-only;
    // always visible — see gating rule in Task 6). 'coa.manage' is owned by
    // settings/coa; 'period.manage' by master. menu-catalog.spec asserts this.
    {
        menuKey: 'journal',
        labelTh: 'บันทึกบัญชี',
        readKeys: ['journal.read'],
        writeKeys: [
            'journal.create',
            'journal.update',
            'journal.submit',
            'journal.approve',
            'journal.reject',
            'journal.return',
            'journal.post',
            'journal.delete',
        ],
    },
    {
        menuKey: 'fixedasset',
        labelTh: 'สินทรัพย์ถาวร',
        readKeys: [],
        writeKeys: [
            'fixedasset.create',
            'fixedasset.receive',
            'fixedasset.dispose',
            'fixedasset.depreciation.run',
            'fixedasset.attachment.manage',
            'assetmaster.manage',
        ],
    },
    {
        menuKey: 'lva',
        labelTh: 'ของมูลค่าน้อย (LVA)',
        readKeys: ['lva.read'],
        writeKeys: [
            'lva.create',
            'lva.update',
            'lva.printLabel',
            'lva.transfer',
            'lva.reassign',
            'lva.markDamaged',
            'lva.markLost',
            'lva.dispose',
            'lva.count.create',
            'lva.count.perform',
            'lva.count.approve',
        ],
    },
    {
        menuKey: 'prepaid',
        labelTh: 'ค่าใช้จ่ายล่วงหน้า',
        readKeys: [],
        writeKeys: [
            'prepaid.create',
            'prepaid.openingbalance',
            'prepaid.run.submit',
            'prepaid.run.approve',
            'prepaid.run.reverse',
            'prepaid.terminate',
            'prepaid.modify',
            'prepaid.suspend',
            'prepaid.expensedirect',
            'prepaid.attachment.manage',
        ],
    },
    {
        menuKey: 'lease',
        labelTh: 'สัญญาเช่า TFRS 16',
        readKeys: [],
        writeKeys: ['lease.create', 'lease.run', 'lease.modify', 'lease.terminate'],
    },
    {
        menuKey: 'glsched',
        labelTh: 'กระทบยอด GL & ประกอบบัญชี',
        readKeys: [],
        writeKeys: [
            'glsched.account.manage',
            'glsched.manage',
            'glsched.writeoff',
            'glsched.certify',
            'glsched.lock',
        ],
    },
    {
        menuKey: 'cip',
        labelTh: 'งานระหว่างก่อสร้าง (CIP)',
        readKeys: ['cip.project.read'],
        writeKeys: [
            'cip.project.create',
            'cip.costentry.create',
            'cip.clearing.receive',
            'cip.capitalize.submit',
            'cip.capitalize.approve',
            'cip.borrowing.run',
            'cip.borrowing.approve',
            'cip.writeoff',
            'cip.retention.release',
            'cip.lifecycle.manage',
        ],
    },
    {
        menuKey: 'empben',
        labelTh: 'TAS 19 ผลประโยชน์พนักงาน',
        readKeys: ['empben.read'],
        writeKeys: [
            'empben.valuation.create',
            'empben.valuation.adopt',
            'empben.monthly.run',
            'empben.settlement.create',
            'empben.remeasurement.create',
            'empben.approve',
            'empben.reject',
            'empben.return',
            'empben.reverse',
        ],
    },
    {
        menuKey: 'opcontract',
        labelTh: 'สัญญาดำเนินงาน',
        readKeys: [],
        writeKeys: [
            'opcontract.manage',
            'opcontract.submit',
            'opcontract.approve',
            'opcontract.renew',
            'opcontract.terminate',
            'opcontract.rate.manage',
            'opcontract.accrue.run',
            'opcontract.accrue.reverse',
        ],
    },
    {
        menuKey: 'ar',
        labelTh: 'ลูกหนี้การค้า',
        readKeys: [
            'ar.invoice.read',
            'ar.receipt.read',
            'ar.aging.read',
            'ar.billingnote.read',
            'ar.pdc.read',
            'ar.advance.read',
        ],
        writeKeys: [
            'ar.invoice.create',
            'ar.invoice.creditoverride',
            'ar.receipt.create',
            'ar.creditnote.create',
            'ar.creditnote.approve',
            'ar.invoice.void',
            'ar.invoice.void.approve',
            'ar.billingnote.create',
            'ar.billingnote.cancel',
            'ar.pdc.create',
            'ar.pdc.manage',
            'ar.advance.create',
            'ar.advance.manage',
        ],
    },
    {
        menuKey: 'ap',
        labelTh: 'เจ้าหนี้การค้า',
        readKeys: [],
        writeKeys: [
            'apbill.create',
            'apbill.approve',
            'appayment.run',
            'appayment.create',
            'appayment.approve',
            'apcreditnote.create',
            'apcreditnote.approve',
            'paymentterm.manage',
            'recurringbill.manage',
        ],
    },
    {
        menuKey: 'suppliers',
        labelTh: 'ผู้ขาย (Suppliers)',
        readKeys: ['supplier.read'],
        writeKeys: [
            'supplier.create',
            'supplier.update',
            'supplier.verify',
            'vendorbank.request',
            'vendorbank.approve',
        ],
    },
    {
        menuKey: 'pettycash',
        labelTh: 'เงินสดย่อย',
        readKeys: ['pettycash.read', 'pettycash.count.read', 'pettycash.close.read'],
        writeKeys: [
            'pettycash.create',
            'pettycash.replenish',
            'pettycash.submit',
            'pettycash.approve',
            'pettycash.count.create',
            'pettycash.count.approve',
            'pettycash.close.create',
            'pettycash.close.approve',
        ],
    },
    {
        menuKey: 'advance',
        labelTh: 'เงินทดรองจ่าย',
        readKeys: [],
        writeKeys: [
            'advance.create',
            'advance.approve',
            'advance.disburse',
            'advance.clear',
            'advance.receipt',
            'advance.remind',
            'advance.writeoff',
        ],
    },
    {
        menuKey: 'accrual',
        labelTh: 'ประมาณการค่าใช้จ่าย',
        readKeys: [],
        writeKeys: ['accrual.template.manage', 'accrual.run', 'accrual.reverse'],
    },
    {
        menuKey: 'payreq',
        labelTh: 'ขออนุมัติจ่ายเงิน',
        readKeys: ['payreq.read'],
        writeKeys: [
            'payreq.create',
            'payreq.submit',
            'payreq.approve',
            'payreq.reject',
            'payreq.return',
            'payreq.pay',
            'payreq.cancel',
        ],
    },
    {
        menuKey: 'doc-ingest',
        labelTh: 'ตรวจเอกสาร AI',
        readKeys: [],
        writeKeys: ['docIngest.create'],
    },
    {
        menuKey: 'vat',
        labelTh: 'ภาษีมูลค่าเพิ่ม',
        readKeys: [],
        writeKeys: [
            'vat.filing.manage',
            'vat.filing.create',
            'vat.writeoff.create',
            'vat.writeoff.approve',
        ],
    },
    {
        menuKey: 'wht',
        labelTh: 'ภาษีหัก ณ ที่จ่าย',
        readKeys: [],
        writeKeys: ['wht.cert.manage', 'wht.remittance.confirm', 'wht.filing.manage'],
    },
    {
        menuKey: 'taxrecon',
        labelTh: 'กระทบยอดภาษี GL ↔ แบบ',
        readKeys: [],
        writeKeys: ['taxrecon.manage'],
    },
    {
        menuKey: 'taxadj',
        labelTh: 'ภาษีนิติบุคคล (ภ.ง.ด.50)',
        readKeys: [],
        writeKeys: ['taxadjustment.manage', 'taxadjustment.approve'],
    },
    {
        menuKey: 'reclass',
        labelTh: 'รายการจัดประเภท (Reclass)',
        readKeys: [],
        writeKeys: ['reclass.manage', 'reclass.post', 'reclass.reverse'],
    },
    {
        menuKey: 'ppemove',
        labelTh: 'PPE Movement (TAS 16)',
        readKeys: [],
        writeKeys: ['ppemovement.manage'],
    },
    {
        menuKey: 'cfforecast',
        labelTh: 'Cashflow Forecast',
        readKeys: [],
        writeKeys: ['cashflow.manage'],
    },
    {
        menuKey: 'fxreval',
        labelTh: 'FX Revaluation (TAS 21)',
        readKeys: [],
        writeKeys: ['fx.rate.manage', 'fx.reval.run', 'fx.reval.reverse'],
    },
    {
        menuKey: 'proptax',
        labelTh: 'ภาษีที่ดิน & ป้าย',
        readKeys: [],
        writeKeys: ['propertytax.create', 'propertytax.pay', 'propertytax.cancel'],
    },
    {
        menuKey: 'recon',
        labelTh: 'กระทบยอดธนาคาร',
        readKeys: [],
        writeKeys: ['bankrecon.manage', 'bankrecon.finalize'],
    },
    {
        menuKey: 'master',
        labelTh: 'Master Data',
        readKeys: [],
        writeKeys: [
            'bankaccount.manage',
            'branch.manage',
            'customer.manage',
            'vendor.manage',
            'department.manage',
            'documenttype.manage',
            'voucherbook.manage',
            'employee.manage',
            'loan.manage',
            'period.manage',
            'project.manage',
        ],
    },
    { menuKey: 'settings/coa', labelTh: 'ตั้งค่าผังบัญชี', readKeys: [], writeKeys: ['coa.manage'] },
    {
        menuKey: 'settings/roles',
        labelTh: 'บทบาท & สิทธิ์',
        readKeys: [],
        writeKeys: ['role.manage'],
    },
    {
        menuKey: 'settings/users',
        labelTh: 'ผู้ใช้ & บทบาท',
        readKeys: [],
        writeKeys: ['user.role.assign', 'user.manage'],
    },
    {
        menuKey: 'settings/audit',
        labelTh: 'บันทึกการตรวจสอบ',
        readKeys: [],
        writeKeys: ['user.manage'],
    },
    {
        menuKey: 'settings/approval-matrix',
        labelTh: 'เกณฑ์อนุมัติ',
        readKeys: [],
        writeKeys: ['approval.manage'],
    },
    {
        menuKey: 'asset-categories',
        labelTh: 'หมวดสินทรัพย์',
        readKeys: [],
        writeKeys: ['assetcategory.manage'],
    },
    { menuKey: 'pclose', labelTh: 'ปิดงวดบัญชี', readKeys: [], writeKeys: ['periodclose.manage'] },
];
export function menuAccessKeys(m) {
    return [...new Set([...m.readKeys, ...m.writeKeys])];
}
export function menuTriState(m, held) {
    const hasAllRead = m.readKeys.every((k) => held.has(k));
    const hasAnyRead = m.readKeys.some((k) => held.has(k));
    const hasAllWrite = m.writeKeys.every((k) => held.has(k));
    const hasAnyWrite = m.writeKeys.some((k) => held.has(k));
    if (!hasAnyRead && !hasAnyWrite)
        return 'none';
    if (hasAllRead && hasAllWrite)
        return 'full';
    if (hasAllRead && !hasAnyWrite)
        return 'read';
    return 'custom';
}
export function applyMenuTriState(m, state, current) {
    const menuKeys = new Set([...m.readKeys, ...m.writeKeys]);
    const next = new Set([...current].filter((k) => !menuKeys.has(k)));
    if (state === 'read')
        m.readKeys.forEach((k) => next.add(k));
    if (state === 'full')
        menuKeys.forEach((k) => next.add(k));
    return next;
}
//# sourceMappingURL=menu-catalog.js.map